import { AuditList, AuditSheet, AuditAssets, LedgerDetails } from "../Components/index.js";

export default [
    // {path: '/voucher/recipe', component: RecipeIndex, name: 'recipe.list'},
    // {path: '/voucher/recipe/create', component: RecipeCreate, name: 'recipe.create'},
    // {path: '/voucher/recipe/purchase/:id', component: RecipePurchase, name: 'recipe.purchase'},
    // {path: '/voucher/recipe/:id/edit', component: RecipeEdit, name: 'recipe.edit'},
    // {path: '/voucher/recipe/:id/view', component: RecipeView, name: 'recipe.view'},

    // {path: '/audit/stock', component: AuditIndex, name: 'audit.stock'},
    // {path: '/audit/assets', component: AuditAssets, name: 'audit.assets'},
    {
        path: "/account/balance-sheet/view",
        component: AuditSheet,
        name: "account.balance-sheet",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/account/audit-ledger/update",
        component: LedgerDetails,
        name: "account.audit.ledger.update",
        meta: {
            requiresAuth: true,
        },
    },
];
